<div class="skeleton-line skeleton-card" [style.height]="hostHeight">
</div>
